import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {Idle} from "@ng-idle/core";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {Observable, Subject} from "rxjs";
import {environment} from "src/environments/environment";
import {AuthService} from "../../services/auth.service";
import {DeviceDetectService} from "../../services/device-detect.service";
import { AsyncPipe, NgClass, NgStyle } from "@angular/common";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: "app-idle-modal",
    templateUrl: "./idle-modal.component.html",
    styleUrls: ["./idle-modal.component.css"],
    imports: [
    NgStyle,
    NgClass,
    AsyncPipe,
    TranslateModule
]
})
export class IdleModalComponent implements OnInit, OnDestroy {
  @Input() message: string;

  sessionInitialized$: Observable<boolean>;
  isMobile: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<IdleModalComponent>,
    private idle: Idle,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private deviceDetectService: DeviceDetectService,
  ) {
  }

  ngOnInit(): void {
    this.isMobile = this.deviceDetectService.isMobile;

    this.sessionInitialized$ = this.authService.isSessionInitialized$();
    this.idle.onTimeoutWarning
      .pipe(takeUntil(this.destroy$))
      .subscribe((countdown: number) => {
      this.message =
        this.translate.instant("idle.sessionExpires") +
        countdown +
        this.translate.instant("idle.inSeconds");
      if (countdown === 1) {
        this.message = "";
      }
    });
  }

  logout() {
    this.idle.timeout();
  }

  stay() {
    this.sessionInitialized$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLogged) => {
      if (isLogged) {
        this.idle.stop();
        this.idle.setIdle(environment.session.sessionLength);
        this.idle.setTimeout(environment.session.idleLength);
        this.idle.watch();
      } else {
        this.onClose();
      }
    });
  }

  onLogin() {
    this.router.navigate(["/login"]);
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
